import { makePopupApi } from '../utils/plugin'
import confirm from '../managers/confirm'

export default makePopupApi('confirm', confirm)
